import { httpClient } from "@coworker/http-client";
import { useQuery } from "@tanstack/react-query";
import { INTERVAL } from "@coworker/app/src/constants/clientTime";
import { ImageDetails } from "../types/ImageDetailsType";

async function fetchTaskImagesDetails(taskId: string) {
  return await httpClient.tasks.get<ImageDetails[]>(
    `/v1/task/${taskId}/images`
  );
}

export function useTaskImagesDetails(taskId: string) {
  return useQuery<ImageDetails[]>({
    queryKey: ["task", "images", taskId],
    queryFn: async () => await fetchTaskImagesDetails(taskId),
    staleTime: INTERVAL.HOUR,
    enabled: !!taskId,
  });
}
